module.exports = __webpack_public_path__ + "img/cp-event-date.9a15c718.svg";